import React, { useState, useEffect } from 'react';

const CookieNotice: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookieNoticeAccepted')) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookieNoticeAccepted', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-[#0A4A7A] text-white p-4 z-50">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm">
          Denna webbplats använder cookies från Google Maps för att visa vår plats. Genom att fortsätta använda sidan godkänner du detta. <a href="/privacy" className="underline">Läs mer</a>
        </p>
        <button onClick={accept} className="bg-white text-[#0A4A7A] px-6 py-2 rounded font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap">
          Jag förstår
        </button>
      </div>
    </div>
  );
};

export default CookieNotice;
